/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ApproveSkillSuggestionRequestBody,
  ApproveSkillSuggestionRequestBody$Outbound,
  ApproveSkillSuggestionRequestBody$outboundSchema,
} from "../components/approveskillsuggestionrequestbody.js";

export type ApproveSkillSuggestionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ApproveSkillSuggestionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ApproveSkillSuggestionSecurity = {
  option1?: ApproveSkillSuggestionSecurityOption1 | undefined;
  option2?: ApproveSkillSuggestionSecurityOption2 | undefined;
};

export type ApproveSkillSuggestionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  approveSkillSuggestionRequestBody: ApproveSkillSuggestionRequestBody;
};

/** @internal */
export type ApproveSkillSuggestionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ApproveSkillSuggestionSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ApproveSkillSuggestionSecurityOption1$Outbound,
    ApproveSkillSuggestionSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function approveSkillSuggestionSecurityOption1ToJSON(
  approveSkillSuggestionSecurityOption1: ApproveSkillSuggestionSecurityOption1,
): string {
  return JSON.stringify(
    ApproveSkillSuggestionSecurityOption1$outboundSchema.parse(
      approveSkillSuggestionSecurityOption1,
    ),
  );
}

/** @internal */
export type ApproveSkillSuggestionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ApproveSkillSuggestionSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ApproveSkillSuggestionSecurityOption2$Outbound,
    ApproveSkillSuggestionSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function approveSkillSuggestionSecurityOption2ToJSON(
  approveSkillSuggestionSecurityOption2: ApproveSkillSuggestionSecurityOption2,
): string {
  return JSON.stringify(
    ApproveSkillSuggestionSecurityOption2$outboundSchema.parse(
      approveSkillSuggestionSecurityOption2,
    ),
  );
}

/** @internal */
export type ApproveSkillSuggestionSecurity$Outbound = {
  Option1?: ApproveSkillSuggestionSecurityOption1$Outbound | undefined;
  Option2?: ApproveSkillSuggestionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ApproveSkillSuggestionSecurity$outboundSchema: z.ZodMiniType<
  ApproveSkillSuggestionSecurity$Outbound,
  ApproveSkillSuggestionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ApproveSkillSuggestionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ApproveSkillSuggestionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function approveSkillSuggestionSecurityToJSON(
  approveSkillSuggestionSecurity: ApproveSkillSuggestionSecurity,
): string {
  return JSON.stringify(
    ApproveSkillSuggestionSecurity$outboundSchema.parse(
      approveSkillSuggestionSecurity,
    ),
  );
}

/** @internal */
export type ApproveSkillSuggestionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ApproveSkillSuggestionRequestBody: ApproveSkillSuggestionRequestBody$Outbound;
};

/** @internal */
export const ApproveSkillSuggestionRequest$outboundSchema: z.ZodMiniType<
  ApproveSkillSuggestionRequest$Outbound,
  ApproveSkillSuggestionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    approveSkillSuggestionRequestBody:
      ApproveSkillSuggestionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      approveSkillSuggestionRequestBody: "ApproveSkillSuggestionRequestBody",
    });
  }),
);

export function approveSkillSuggestionRequestToJSON(
  approveSkillSuggestionRequest: ApproveSkillSuggestionRequest,
): string {
  return JSON.stringify(
    ApproveSkillSuggestionRequest$outboundSchema.parse(
      approveSkillSuggestionRequest,
    ),
  );
}
